module.exports = __webpack_public_path__ + "7bf8e69c96e740051957279b0d9072b0.pdf";